import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
    ACTIVE,
    DEACTIVE,
    ROLE,
  SWAL_SETTINGS,
  showFilterlist,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  globalLoader,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
// import * as doctorService from "../../../center/services/doctor.services.js";
import { List, Status, Delete } from "../../services/doctor.services";
import { GetAllCenters } from "../../services/usermgmt.services";
import CenterFilter from "../../common/centerFilter";

const DoctorsTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    // { title: t("sidebar_link_restaurant"), url: "" },
    { title: 'Dcotor Management', url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [centers, setCenters] = useState([]);

  useEffect(() => {
      GetAllCenters()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
    }, []);
  

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        if(searchParams.get('center_id')){
          formData.append("center_id", searchParams.get('center_id'));
        }
        List(formData, ROLE.SUPER_ADMIN)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

//   const viewfunction = (row) => {
//     navigate(
//       `/admin/center-management/center/view/${row._id}`
//     );
//   };

  const ChangeStatus = (doctor_id, status) => {
      
      Swal.fire({
        customClass: "swal-wide",
        title: t("admin.message.msg_are_you_sure"),
        text: t("Do you really want to change the status."),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#403fad",
        cancelButtonColor: "#f1388b",
        confirmButtonText: t("admin.button.btn_yes"),
        cancelButtonText: t("admin.button.btn_cancel")
      }).then((result) => {
        if (result.isConfirmed) {
          Status({ o_id: doctor_id, status: status ? ACTIVE : DEACTIVE })
            .then((response) => {
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                setStatusUpdate(!statsupdate);
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              console.log("error===>");
            });
        }
      });
  };

  const viewfunction = (row) => {
    navigate(
      `/admin/doctor-management/doctor/view/${row._id}`
    );
  };

  function Deletefunction(data, email) {
      Swal.fire({
        customClass: "swal-wide",
        title: t("admin.cafes.msg_are_you_sure"),
        text: t("admin.cafes.you_not_be_able_to_revert_this"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: t("admin.cafes.btn_cancel"),
        confirmButtonColor: "#403fad",
        cancelButtonColor: "#f1388b",
        confirmButtonText: t("admin.cafes.btn_yes_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          const formdata = new FormData();
          let ids = Array.isArray(data) ? data : [data];
          // formdata.append("o_id", row._id);
          formdata.append("o_id", JSON.stringify(ids))
          formdata.append("email", email)
          Delete(ids)
            .then((response) => {
              // console.log("🚀 ~ .then ~ response:", response);
              setStatusUpdate(!statsupdate);
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: "Doctor deleted successfully",
                  ...SWAL_SETTINGS,
                });
  
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              console.log("deleteError");
            });
        }
      });
  }

  
//   function Deletefunction(data, email) {
//     Swal.fire({
//       customClass: "swal-wide",
//       title: t("admin.cafes.msg_are_you_sure"),
//       text: t("admin.cafes.you_not_be_able_to_revert_this"),
//       icon: "warning",
//       showCancelButton: true,
//       cancelButtonText: t("admin.cafes.btn_cancel"),
//       confirmButtonColor: "#403fad",
//       cancelButtonColor: "#f1388b",
//       confirmButtonText: t("admin.cafes.btn_yes_delete"),
//     }).then((result) => {
//       if (result.isConfirmed) {
//         const formdata = new FormData();
//         let ids = Array.isArray(data) ? data : [data];
//         // formdata.append("o_id", row._id);
//         formdata.append("o_id", JSON.stringify(ids))
//         formdata.append("email", email)
//         Delete(ids)
//           .then((response) => {
//             // console.log("🚀 ~ .then ~ response:", response);
//             setStatusUpdate(!statsupdate);
//             if (response.success) {
//               Swal.fire({
//                 icon: "success",
//                 text: "Center deleted successfully",
//                 ...SWAL_SETTINGS,
//               });

//             } else {
//               Swal.fire({
//                 icon: "error",
//                 text: handleServerValidations(response),
//                 ...SWAL_SETTINGS,
//               });
//             }
//           })
//           .catch((error) => {
//             console.log("deleteError");
//           });
//       }
//     });
//   }

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // console.log(search);
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
    $("#defaultcenter")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/doctor-management/doctor/${params.pgno}/edit/${row._id}`
    );
  };
  
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                Doctor Management
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                {/* Center Filter */}
                <div className="me-3">
                  <CenterFilter
                    data={centers}
                    prepareSearch={prepareSearch}
                  />
                </div>    
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("admin.filter_placeholder.btn_reset_filter")}
                </button>
                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/doctor-management/doctor/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                  {/* <th style={{ width: "50px" }}>{t("Logo")}</th> */}
                    <th>
                      <div className="sorting_column">
                        <span>Doctor ID</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="center_register_id"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Doctor Name</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="name"
                        />
                      </div>
                    </th>
                    {/* <th>Centre Name</th> */}
                    <th>Email</th>
                    <th>Password</th>
                    <th>Phone</th>
                    <th>Centre</th>
                    <th>Centre ID</th>
                    {/* <th className="">{t("admin.cafes.list_heading_phone_number")}</th>
                    <th className="">{t("Doctors")}</th> */}
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>Registered Date</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th> 
                    <th className="status_head">{t("admin.list_heading.list_heading_status")}</th>
                    <th className="action_head">{t("admin.list_heading.list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr
                              key={i}
                            >
                              {/* <td>
                                {row?.center_logo ? (
                                  <div className="row_image">
                                    <img
                                      className="rounded"
                                      alt="profile"
                                      src={row?.center_logo}
                                    />
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </td> */}
                              <td>{row?.doctor_register_id ? '#'+(row?.doctor_register_id) : '-'}</td>
                              <td>
                                {row?.name ? (
                                  <div className="d-flex">
                                    {row?.name ? capitalizeFirstLetter(TrimText(row.name,30)) : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                              {/* <td>{row?.center_name ? row.center_name : "N/A"}</td> */}
                              <td>{row?.email ? row.email : "N/A"}</td>
                              <td>{row?.password_to_display ? row.password_to_display : "N/A"}</td>
                              <td>{row?.phone_number ? row.phone_number : "N/A"}</td>
                              <td>{row?.centers.length ? capitalizeFirstLetter(TrimText(row.centers[0].center?.name,30)) : "N/A"}</td>
                              <td>{row?.centers.length > 0 ? '#'+(row.centers[0].center?.center_register_id) : "-"}</td>
                              {/* <td>30</td> */}

                              <td>
                                {row.createdAt
                                  ? formateDateWithMonth(row.createdAt)
                                  : "N/A"}
                              </td>
                              <td>
                                {row.status === 1 ? (
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      ChangeStatus(row?._id, 0);
                                    }}
                                  >
                                    {t("Unblock")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn ripple btn-secondary"
                                    onClick={() => {
                                      ChangeStatus(row?._id, 1);
                                    }}
                                  >
                                    {t("Block")}
                                  </button>
                                )}
                              </td>

                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      viewfunction(row);
                                    }}
                                  >
                                    {t("admin.button.btn_view")}
                                  </button>

                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => {
                                      goToEdit(row);
                                    }}
                                  >
                                    {t("admin.button.btn_edit")}
                                  </button>
                                  
                                  {/* <button
                                    className="btn ripple btn-danger mlAction"
                                    onClick={() => {
                                      Deletefunction(row?._id, row?.email);
                                    }}
                                  >
                                    {t("admin.button.btn_delete")}
                                  </button> */}

                                  {/* <div className="btn-group mlAction">
                                    <button
                                      type="button"
                                      className="btn btn-dark dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      {t("admin.button.btn_more")}
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li>
                                        <button
                                          className="dropdown-item"
                                          onClick={() => {
                                            Deletefunction(row?._id, row?.email);
                                          }}
                                        >
                                          {t("admin.button.btn_delete")}
                                        </button>
                                      </li>    
                                    </ul>
                                  </div> */}
                                  
                                </div>
                              </td> 
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("admin.message.msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "Cafes",
                    path: "/admin/doctor-management/doctor/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div> 

    </>
  );
};

export default DoctorsTable;
